<div class="parent-block">
  @if (isLoopParent$()) {
    <span class="text__sm fw__500">
      Each round runs one complete iteration of each child loop, including all its pages. Children with fewer items finish earlier and are skipped in later
      rounds. Child order is authored or randomized once per participant and reused each round. Each child's item order is configured separately.
    </span>
  }
  @if (visibleSubBlocks$().length > 0) {
    <div class="parent-block__header">
      <h2 class="text__md">Sub Blocks</h2>
      <mat-slide-toggle
        [labelPosition]="'before'"
        data-testid="parent-child-order-randomized-toggle"
        [color]="'primary'"
        [formControl]="activeBlock().controls.randomizedInd | toFormControl"
        [checked]="activeBlock().value.randomizedInd"
      >
        Randomized
      </mat-slide-toggle>
    </div>
  }
  <mat-accordion multi>
    @for (subBlock of visibleSubBlocks$(); track subBlock.control.value.id) {
      <mat-expansion-panel #panel [formGroup]="subBlock.control" class="parent-block__subblock">
        <mat-expansion-panel-header [attr.data-testid]="'parent-child-' + subBlock.control.value.id + '-header'">
          <mat-panel-title class="parent-block__subblock-header">
            <div class="parent-block__subblock-header__title">
              <div class="eiq-id-badge">
                <fa-icon [icon]="blockTypeConfig[subBlock.control.value.type].icon"></fa-icon>
                <span>{{ subBlock.control.value.id }}</span>
              </div>
              <span class="survey-editor__html-content text__md" [innerHTML]="subBlock.control.value.title"></span>
            </div>
            <button
              mat-icon-button
              title="Remove block"
              color="warn"
              [attr.data-testid]="'parent-block-remove-' + subBlock.control.value.id + '-button'"
              (click)="onRemoveBlock(subBlock.control.value.id)"
            >
              <fa-icon [icon]="faTrashCan"></fa-icon>
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panel.expanded) {
          <div class="parent-block__subblock-details">
            <div class="editor-question-form__input">
              <span class="label text__md">Title</span>
              <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  formControlName="title"
                  [attr.data-testid]="'parent-child-title-' + subBlock.control.value.id + '-input'"
                  autocomplete="off"
                  (change)="onSubBlockTitleChanged(subBlock.control.value.id)"
                />
              </mat-form-field>
            </div>
            <div class="editor-question-form__input">
              <span class="label text__md">Add Notes: <span class="text__xs caption">(Optional)</span></span>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="description"
                  [attr.data-testid]="'parent-child-notes-' + subBlock.control.value.id + '-input'"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>

          <mat-divider></mat-divider>

          @switch (subBlock.control.value.type) {
            @case (blockType.Loop) {
              <empathy-loop-block-form [activeBlock]="subBlock.control" [isSecondChild]="subBlock.isSecondChild"></empathy-loop-block-form>
            }
            @case (blockType.Group) {
              <empathy-group-block-form [activeBlock]="subBlock.control" [isSecondChild]="subBlock.isSecondChild"></empathy-group-block-form>
            }
          }
        }
      </mat-expansion-panel>
    }
  </mat-accordion>

  <div #loadMoreSubBlocksTrigger></div>

  @if (!hasMoreSubBlocks$()) {
    <button mat-stroked-button color="primary" data-testid="parent-block-add-sub-block-button" (click)="onAddBlock()">Add Sub-block</button>
  }
</div>
